import React, { ComponentProps } from 'react'
import { Link, LinkProps } from 'react-router-dom'

import ListItem from '@material-ui/core/ListItem'

type Props = ComponentProps<typeof ListItem> & {
  to?: LinkProps['to']
}

const EventLink: React.SFC<Props> = ({ to, children, onMouseDown, onMouseUp, className }) => {
  const props = { children, onMouseDown, onMouseUp, className }
  return to ? <Link to={to} {...props as any} /> : <div {...props} />
}

export default EventLink
